"use client";
import Image from 'next/image';
import React from 'react';


const Logo = () => {
    return (
        <>
            <Image
                src={"/assets/images/final-logo.png"}
                alt="Logo"
                width={200}
                height={100}
                className="w-64"
            />
        </>
    )
}

export default Logo